<div class="mobile-nav-title"></div>
<div class="page-content">
  <div class="container-fluid mb-5">
      <div class="col">
          <div class="mb-4 mt-4">
              <img class="bidit-logo" alt="BiditWeb" src="assets/img/Bidit_Logo.png" />
              <p class="text-white" i18n>Welcome to IDI's BIDIT <br />Contractor Resource Tool</p>
          </div>

          <div *ngIf="showIDI" class="w-100 pt-2 mb-2">
              <div class="card card-transparent w-100">
                  <div class="alert-panel card-body text-white">
                      <div class="row">
                          <div class="col-sm-3">
                              Alerts:
                          </div>
                          <div class="col-sm-9">
                              IDI Admin features are not supported on the mobile site
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div *ngIf="summary.dashboardAlerts && summary.dashboardAlerts.length > 0" class="w-100 pt-2 mb-2">
              <div class="card card-transparent w-100">
                  <div class="alert-panel card-body text-white">
                      <div class="row">
                          <div class="col-sm-3">
                              Alerts:
                          </div>
                          <div class="col-sm-9">
                              <ul>
                                  <li *ngFor="let alert of summary.dashboardAlerts">
                                      {{alert}}
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <p class="text-white" i18n>Now you can leverage decades of experience from IDI in helping partners grow their business</p>

          <a (click)="toggleFullSite()" class="btn btn-bidit-navigate mb-4">
              <span i18n>View Full Site</span>
          </a>

          <select name="locale" class="form-control select-bidit w-50" [(ngModel)]="locale" (ngModelChange)="updateLocale()">
              <option value="en">English</option>
              <option value="es">Español</option>
          </select>
      </div>
  </div>
  <div class="clearfix"></div>
</div>
